import React, { forwardRef, useRef } from 'react';

import { Box, Flex } from '@chakra-ui/react';
import { LineChart } from '@mesh.ai/rabbit';

import { Download } from 'assets/assetsV1/iconComponents';

import { Button } from 'uiToolkitV1/Button';
import { useExpandableContainer } from 'uiToolkitV1/ExpandableContainerProvider';
import { SkeletonLoader } from 'uiToolkitV1/SkeletonLoader';
import { TextHeader3 } from 'uiToolkitV1/Typography';

const PlotBarChart = forwardRef(({ chartData, mode, isExpanded }, ref) => (
  <div className="rabbit-ds" style={{ height: isExpanded ? '90%' : '100%' }}>
    <LineChart
      ref={ref}
      nodes={chartData.nodes}
      xAxisValues={chartData.xaxis}
      series={chartData.series}
      xAxisLabel="Review Cycle"
      yAxisLabel="Average Score"
      mode={mode}
      connectNulls
      yAxisDomain={[chartData.yaxisRange.start, chartData.yaxisRange.end]}
      tooltipTitle="Average Progress"
    />
  </div>
));

const TrendLineChart = ({ trendLineChartData, isLoading }) => {
  const chartRef = useRef(null);
  const { isExpanded = false, onMiniToExpandedOperation } = useExpandableContainer();

  const onDownloadClick = () => {
    if (isExpanded) {
      chartRef?.current?.download();
      return;
    }
    // this all logic is to download expanded chart even when the download button is clicked in mini mode
    onMiniToExpandedOperation(() => chartRef?.current?.download());
  };

  if (isLoading) {
    return <SkeletonLoader />;
  }

  return (
    <Flex h="100%" flexDirection="column" m={isExpanded ? '0px 12px' : '0px'}>
      <Flex justifyContent="space-between" alignItems="center" mb={3} ml="5px">
        <TextHeader3 bold color="text.g1" ml="6px">
          Average Progress
        </TextHeader3>
        <Flex bg="#EBEFF3" borderRadius="4px" mr="45px" height="35px">
          <Button variant="tertiary" EndIcon={Download} onClick={onDownloadClick} height="35px" />
        </Flex>
      </Flex>

      <Box h={isExpanded ? '100%' : '80%'}>
        <PlotBarChart
          ref={chartRef}
          chartData={trendLineChartData}
          mode={isExpanded ? 'full' : 'mini'}
          isExpanded={isExpanded}
        />
      </Box>
    </Flex>
  );
};

export default TrendLineChart;
